module.exports = __webpack_public_path__ + "img/search-blue.07264975.svg";